import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/loading
 * @param {String} type - type for sucess/error/loading
 */

export const categoryDataSuccess = (
  payload = {},
  type = types.CATEGORY_DATA_SUCCESS
) => {
  return {
    type,
    payload
  };
};

export const categoryDataLoading = (
  payload = {},
  type = types.LOADING_CATEGORY_DATA
) => {
  return {
    type,
    payload
  };
};
